module.exports = "/assets/img/ipallets/アプリ開発体験.png";